<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { get_local_ip, real_id } from '../../../../../helpers/interface_helpers';
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	import { tooltipText } from '../tooltip_text';
	//Services
	import { localReq, postReq } from '../../../../../services/http';
	import { format } from '../../../../../services/i18n';
	//Stores
		//Deisgn system components
	import { Button, Checkbox, Radio, toast, Tooltip } from '@Shelly/shelly-design-system';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);

	let settings = $settingsStore;

	const btn_types = [
		'momentary',
		'toggle',
		'edge',
		'detached',
		'action',
		'cycle',
		'momentary_on_release',
	];

	let reverse = $settingsStore[device.category + 's'][device.channel].btn_reverse;
	let cacheReverse = reverse;

	let index = btn_types.indexOf($settingsStore[device.category + 's'][device.channel].btn_type);
	let cacheIndex = index;

	let loading = false;

	let disabled =
		$settingsStore[device.category + 's'][device.channel].default_state === 'switch';
	let toolTipMesage = (type: string) => {
		return {
			message: 'btn_type_unavailable_switch_info_toast',
			values: { pod_type: type },
		};
	};
	const localIp = get_local_ip(id);

	const toggleReverse = () => {
		reverse = !reverse;
	};

	const setType = (val) => {
		index = val;
	};

	const sentRequests = async () => {
		let setBtnType; //prepare variable for first promise
		let handleToggle; //prepare variable for second promise

		if (cacheIndex !== index) {
			loading = true;
			if (localIp) {
				setBtnType = await localReq(
					device,
					`${localIp}/settings/${device.category}/${device.channel}`,
					'post',
					{
						btn_type: btn_types[index],
					},
				);
			} else {
				setBtnType = await postReq(`/device/${device.category}/settings/button_type`, {
					id: id,
					channel: device.channel,
					type: btn_types[index],
				});
			}
		}
		if (cacheReverse !== reverse) {
			loading = true;
			if (localIp) {
				handleToggle = await localReq(
					device,
					`${localIp}/settings/${device.category}/${device.channel}`,
					'post',
					{
						btn_reverse: reverse ? 1 : 0,
					},
				);
			} else {
				handleToggle = await postReq(`/device/${device.category}/settings/reverse_toggle`, {
					id: id,
					channel: device.channel,
					type: reverse ? 1 : 0,
				});
			}
		}
		Promise.all([setBtnType, handleToggle]).then((res) => {
			//here based on changed settings we will have two or less requests. If no setting changed array's member will be undefined
			if (typeof res[0] !== 'undefined') {
				if (res[0].isok) {
					settings[device.category + 's'][device.channel].btn_type = btn_types[index];
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title:
							$format('btn_type_scc_toast', {
								values: {
									type_value: formatSnakeCaseToTitle(btn_types[index]),
								},
							}) ||
							`Button type was changed to ${formatSnakeCaseToTitle(btn_types[index])}.`,
					});
					cacheIndex = index;
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
					index = cacheIndex;
				}
			}
			if (typeof res[1] !== 'undefined') {
				if (res[1].isok) {
					settings[device.category + 's'][device.channel].btn_reverse = reverse;
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title: $format('swap_inputs_scc_toast') || `Inputs was swapped.`,
					});
					cacheReverse = reverse;
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
					reverse = cacheReverse;
				}
			}
			loading = false;
		});
	};
</script>

<Radio size="m" selected={index.toString()} value={'0'} on:click={() => setType(0)} id="radio-eo4i07r">
	{$format('option_momentary_by_category', {
		values: { device_category: $format(`this_${device.category}`) },
	}) ||
		`Momentary - Set this {device.category} to be "Momentary" switch. Push-for "ON" or Push-for "OFF"`}
	.</Radio
>
{#if index === 0 || index === 6}
	<Radio
		size="m"
		selected={index.toString()}
		value={'6'}
		on:click={() => setType(index === 6 ? 0 : 6)}
		id="radio-6l0pm2x"
		>{$format('button_option_alert_1') ||
			"Don't activate if the button is long pushed. Notice: If short pushed, the relay will be switched only after the button is released."}</Radio
	>
{/if}
<Radio size="m" selected={index.toString()} value={'1'} on:click={() => setType(1)} id="radio-m0if093"
	>{$format('option_toggle_switch_by_category', {
		values: { device_category: $format(`this_${device.category}`) },
	}) ||
		'Toggle Switch - Set this {device.category} to be "Toggle" switch. Act as a flip switch with one state for "ON" and one state for "OFF".'}</Radio
>
<Tooltip placement="top" title={tooltipText(toolTipMesage('switch'), disabled)}>
	<Radio
		size="m"
		selected={index.toString()}
		value={'2'}
		{disabled}
		on:click={() => setType(2)}
		id="radio-m0nka5q"
		>{$format('option_edge_switch_by_category', {
			values: { device_category: $format(`this_${device.category}`) },
		}) ||
			'Edge Switch - Set this {device.category} to be "Edge" switch. Changes state on every hit.'}</Radio
	>
</Tooltip>
<Radio size="m" selected={index.toString()} value={'3'} on:click={() => setType(3)} id="radio-jwufqs5"
	>{$format('option_detached_by_category', {
		values: { device_category: $format(`this_${device.category}`) },
	}) ||
		'Detached Switch - Set this {device.category} to be in "Detached" switch mode - switch is separated from the relays.'}</Radio
>
<Radio size="m" selected={index.toString()} value={'4'} on:click={() => setType(4)} id="radio-t0gfaac"
	>{$format('option_activation_switch') ||
		'Activation Switch - use it for motion sensor. Any input turns "ON" and resets Auto OFF timer.'}</Radio
>
<Checkbox size="m" checked={reverse} on:click={toggleReverse} id="checkbox-b20h746"
	>{$format('option_reverse_inputs') ||
		'Reverse inputs - If you enable this option, the buttons On/Off position will be inverted.'}</Checkbox
>
<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequests}
	>{$format('button_save')}</Button
>
